<div class="tabs-container">
    <tabs (tabClicked)="onTabClicked()">
        <tab title="Inbound">
            <ag-grid-angular class="data-grid " [rowData]="inboundData" [gridOptions]="inboundGridOptions"  [attr.aria-label]="widgetTitle + ' - Inbound'"></ag-grid-angular>
        </tab>
        <tab title="Outbound">
            <ag-grid-angular class="data-grid " [rowData]="outboundData" [gridOptions]="outboundGridOptions"  [attr.aria-label]="widgetTitle + ' - Outbound'"></ag-grid-angular>
        </tab>
    </tabs>
</div>